// Created by gcdd1993 on 2024/8/19

import { TApi } from '@/types/interface';
import { requestGet } from '@/services/request';

// 获取文件的临时下载链接
export async function apiGetTempUploadUrl(params: {
  path: string;
  fileName: string;
  contentType: string;
}): Promise<
  TApi<{
    signedUrl: string;
    actualSignedRequestHeaders: {
      'Content-Type': string;
      Host: string;
    };
  }>
> {
  params.fileName = encodeURIComponent(params.fileName);
  return requestGet('/v1/cert/oss/upload/temporary/url', params);
}
